import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "快速导航",
    links: [
      { label: "首页", path: "/" },
      { label: "漫画分类", path: "/category/all" },
      { label: "关于我们", path: "/about" },
    ],
  },
  {
    title: "热门分类",
    links: [
      { label: "热血漫画", path: "/category/rexue" },
      { label: "恋爱漫画", path: "/category/lianai" },
      { label: "奇幻漫画", path: "/category/qihuan" },
      { label: "玄幻漫画", path: "/category/xuanhuan" },
      { label: "悬疑漫画", path: "/category/xuanyi" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "品牌介绍", path: "/about" },
      { label: "联系方式", path: "/about" },
      { label: "常见问题", path: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="inline-block cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <span className="text-xl font-heading font-bold text-primary-500 whitespace-nowrap">
                土豪漫画
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              韩漫在线免费阅读平台，提供韩漫全集下拉式阅读体验。海量韩国漫画大全，让您轻松畅享沉浸式阅读乐趣。
            </p>
          </div>
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 土豪漫画网 - 韩漫在线免费阅读平台。本站所有内容仅供学习和交流。
          </p>
          <div className="flex items-center gap-5">
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
            >
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}